import { render, staticRenderFns } from "./PrivacyBody.vue?vue&type=template&id=22d65108&scoped=true&"
import script from "./PrivacyBody.vue?vue&type=script&lang=js&"
export * from "./PrivacyBody.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyBody.vue?vue&type=style&index=0&id=22d65108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d65108",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d65108')) {
      api.createRecord('22d65108', component.options)
    } else {
      api.reload('22d65108', component.options)
    }
    module.hot.accept("./PrivacyBody.vue?vue&type=template&id=22d65108&scoped=true&", function () {
      api.rerender('22d65108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Declare/Privacy/PrivacyBody.vue"
export default component.exports